<template>
  <div>
    <StoreSwitcher v-if="isAdmin" />
    <PaymentMethodsReportFilter v-model="filter" @filter="loadPayments" />
    <PaymentMethodsReportList
      hide-warnings
      :payments="payments"
      @refresh="loadPayments"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import withAsyncAction from '@/mixins/withAsyncAction'
import services from '@/services'
import PaymentMethodsReportFilter from './PaymentMethodsReportFilter'
import PaymentMethodsReportList from '@/components/Reports/PaymentMethods/PaymentMethodsReportList'
import { formatDate } from '@/helpers/date'
import StoreSwitcher from '@/components/Stores/StoreSwitcher'

export default {
  name: 'PaymentMethodsReport',
  components: {
    PaymentMethodsReportFilter,
    PaymentMethodsReportList,
    StoreSwitcher
  },
  mixins: [
    withAsyncAction({
      key: 'payments',
      initialState: [],
      fetcher: {
        methodName: 'fetchPaymentMethodsReport',
        handler: services.reports.fetchPaymentMethodsReport
      }
    })
  ],
  data() {
    return {
      filter: {
        fromDate: formatDate(new Date()),
        toDate: formatDate(new Date())
      }
    }
  },
  computed: {
    ...mapGetters('store', ['currentStoreId', 'isAdmin'])
  },
  created() {
    this.loadPayments()
  },
  methods: {
    loadPayments() {
      const storeId = this.currentStoreId
      const { fromDate, toDate } = this.filter
      this.fetchPaymentMethodsReport({ storeId, fromDate, toDate })
    }
  }
}
</script>
